<div class="label">
  <riv-icon *ngIf="icon" [name]="icon" [customSize]="14"></riv-icon>
  {{ label }}
</div>
<div [ngClass]="valueClasses()">{{ value }}</div>
